import { useCallback } from 'react';
import { Mask, Toast } from 'antd-mobile-v5';
import { jsHandleShare } from '@/utils/bridge';
import {
  SHARE_METHOD_NAME,
  DEFAULT_SHARE_MENU,
  SHARE_TO_WECHAT_FRIEND,
  SHARE_TO_WECHAT_MOMENTS,
  SHARE_TO_SAVE_TO_ALBUM,
  SHARE_TO_COPY_LINK,
} from '@/constant/share';
import styles from './index.less';

const ShareMenu = ({
  visible,
  menu = DEFAULT_SHARE_MENU,
  onClose,
  shareData = {},
  onShare,
  onMaskClick = null,
  withCloseIcon = true, // 是否有关闭按钮
}) => {
  const shareCallback = useCallback((res, platform) => {
    let message = '';
    switch (res.code) {
      case 0:
        if (platform === SHARE_TO_SAVE_TO_ALBUM) {
          message = '已保存图片， 请前往分享';
        }
        if (platform === SHARE_TO_COPY_LINK) message = `${SHARE_METHOD_NAME[platform]}成功`;
        // else {
        //   message = `${SHARE_METHOD_NAME[platform]}成功`;
        // }
        break;
      case -1:
        if (platform === SHARE_TO_WECHAT_FRIEND || platform === SHARE_TO_WECHAT_MOMENTS) {
          message = '微信异常，请保存相册后自行分享';
        } else {
          message = '操作出错，请稍后重试';
        }
        break;
      case -2:
        message = '该类型的分享不支持';
        break;
      case -3:
        message = '微信未安装';
        break;
      case -4:
        message = '请前往设置开启图片写入权限';
        break;
      default:
        message = '未知错误，请稍后重试';
        break;
    }
    if (message) {
      Toast.show({ content: message });
    }
  }, []);

  const handleShare = useCallback(
    menu => {
      const shareItem = { ...shareData, type: 0, platform: menu };
      switch (menu) {
        case SHARE_TO_WECHAT_FRIEND:
          shareItem.type = 1;
          break;
        case SHARE_TO_WECHAT_MOMENTS:
          shareItem.type = 1;
          // shareItem.share_image = '';
          break;
        case SHARE_TO_COPY_LINK:
          shareItem.share_title = '';
          shareItem.share_content = '';
          break;
        default:
          break;
      }
      if (onShare) onShare(menu);
      console.log('shareItem: ', shareItem);
      jsHandleShare(
        {
          share_item: shareItem,
        },
        res => shareCallback(res, menu)
      );
    },
    [shareCallback, onShare, shareData]
  );

  return (
    <Mask visible={visible} opacity="thin" onMaskClick={onMaskClick}>
      <div className={styles.shareMenuWrapper}>
        {withCloseIcon && <i className={styles.close} onClick={onClose} />}
        <h5>分享至</h5>
        <ul className={styles.shareMenu}>
          {menu.map(menu => (
            <li key={menu} className={styles[`share-${menu}`]} onClick={() => handleShare(menu)}>
              {SHARE_METHOD_NAME[menu]}
            </li>
          ))}
        </ul>
      </div>
    </Mask>
  );
};

export default ShareMenu;
